import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getTicketPriceTextStyles } from 'common/entities/form/styleConfiguration/selectors';
import {
    setTicketPriceTextFont,
    setTicketPriceTextFontsize,
    setTicketPriceTextColor,
} from 'common/entities/form/styleConfiguration/actions';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import {
    DEFAULT_FONT,
    DEFAULT_TICKET_FONT_SIZE,
    DEFAULT_TICKET_PRICE_COLOR,
} from 'common/entities/form/styleConfiguration/defaultValues';
import DefaultFontTicketStylePanel from './DefaultFontTicketStylePanel';
import { getFormId, getOpenTicketStylingType } from '../../../../selectors';
import { PRICE_QA } from '../../../../constants/ticketDataQa';
import { PRICE_LABEL } from '../../../../constants/formStyleLabels';

const FormStyleTicketEditorPricePanel = (props) => (
    <DefaultFontTicketStylePanel
        ticketPanelQaId={PRICE_QA}
        setTicketPanelFontFamily={props.setTicketPriceTextFont}
        setTicketPanelFontSize={props.setTicketPriceTextFontsize}
        setTicketPanelTextColor={props.setTicketPriceTextColor}
        {...props}
        componentLabel={PRICE_LABEL}
    />
);

FormStyleTicketEditorPricePanel.propTypes = {
    formId: PropTypes.string.isRequired,
    color: styleShapePropTypes,
    font: styleShapePropTypes,
    fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    setTicketPriceTextFont: PropTypes.func.isRequired,
    setTicketPriceTextFontsize: PropTypes.func.isRequired,
    setTicketPriceTextColor: PropTypes.func.isRequired,
};

FormStyleTicketEditorPricePanel.defaultProps = {
    color: getDefaultStyle(DEFAULT_TICKET_PRICE_COLOR),
    font: getDefaultStyle(DEFAULT_FONT),
    fontSize: DEFAULT_TICKET_FONT_SIZE,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const openTicketType = getOpenTicketStylingType(state);

    const { color, font, fontSize } = getTicketPriceTextStyles(state, formId, openTicketType);

    return {
        formId,
        color,
        font,
        fontSize,
    };
};

const mapDispatchToProps = {
    setTicketPriceTextFont,
    setTicketPriceTextFontsize,
    setTicketPriceTextColor,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormStyleTicketEditorPricePanel);
